import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request/index';
import { getQrCode } from '@r1-frontend/api-domru/api-pay/v1/qr/index';
import { getQrLink } from '@r1-frontend/api-domru/api-pay/v1/vtb-pay/qr-core';
import { IVtbPayQrCode } from '@r1-frontend/api-domru/api-pay/v1/vtb-pay/qr-core/dto/IVtbPayQrCode';

import {
    setIsFetching,
    setQrCode,
    setQrFetchingResult,
    setQrLink,
} from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const payBySbp = (amount: number) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        dispatch(setIsFetching(true));

        const {
            auth: { clientPersonal },
            city: { provider: { providerId } },
            seasonTicketPayment: { sbpInfo: { result } },
        } = getState();
        const { agreement } = clientPersonal || {};
        const userAgreement = agreement?.toString() || '';

        if (result === 'error') {
            dispatch(setQrFetchingResult('none'));
        }

        const linkResponse = await doRequest.apiPay<IVtbPayQrCode>(
            getQrLink({ providerId, userAgreement, paySum: amount }),
        );
        if (linkResponse.isSuccess) {
            dispatch(setQrLink(linkResponse.payload.data.payload));
        } else {
            batch(() => {
                dispatch(setQrFetchingResult('error'));
                dispatch(setIsFetching(false));
            });

            return;
        }

        const codeResponse = await doRequest.apiPay<string>(
            getQrCode(providerId, linkResponse.payload.data.payload),
        );

        if (codeResponse.isSuccess) {
            dispatch(setQrCode(codeResponse.payload));
        } else {
            batch(() => {
                dispatch(setQrFetchingResult('error'));
                dispatch(setIsFetching(false));
            });

            return;
        }

        dispatch(setIsFetching(false));
    };
};

export default payBySbp;
